import { render } from "./privacy-policy.vue?vue&type=template&id=2e66ffb6"
import script from "./privacy-policy.js?vue&type=script&lang=js"
export * from "./privacy-policy.js?vue&type=script&lang=js"

import "./privacy-policy.vue?vue&type=style&index=0&id=2e66ffb6&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__